import { logger } from 'redux-logger';
import type { Middleware } from 'redux';
import appReducer from '@/redux/reducers';

import { initialState as auth } from '@/redux/auth/reducer';
import { initialState as user } from '@/redux/user/reducer';
import { initialState as campaign } from '@/redux/campaign/reducer';
import { initialState as challenges } from '@/redux/challenges/reducer';
import { isLocalDev } from '@/utils/env';

import { type ConfigureStoreOptions, configureStore } from '@reduxjs/toolkit';

export const preloadedState = { auth, user, campaign, challenges };

const rootStoreConfig: ConfigureStoreOptions = {
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      [isLocalDev() && logger].filter(Boolean) as Middleware[]
    ),

  devTools: isLocalDev(),
  reducer: appReducer,
  preloadedState
};

export default configureStore(rootStoreConfig);
